import { Button } from '@fagmobler/ui';
import { ServerProduct } from '@/lib/janitsjar/Product';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import { useNavigation } from '@/contexts/navigation';
import { useEffect, useState } from 'react';
import { trackEvent } from '@/lib/analytics';
import type { FagmoblerPublicOmniumProduct } from '@fagmobler/types';
import {
  useCurrentStore,
  useCurrentStoreStock,
} from '@/cataloguePages/productPageWithVariants/helpers';

type ClickCollectButtonProps = {
  product: ServerProduct;
  omniumProduct: FagmoblerPublicOmniumProduct;
};

export default function ClickCollectButton({
  product,
  omniumProduct,
}: ClickCollectButtonProps) {
  const [listenForStoreChange, setListenForStoreChange] = useState(false);
  const { setClickAndCollect, setShowStoreStock } = useNavigation();
  const currentStore = useCurrentStore();
  const currentStoreStock = useCurrentStoreStock(product.stock ?? []);

  const openClickAndCollect = () => {
    if (currentStore) {
      setClickAndCollect({
        product: omniumProduct,
        visible: true,
        quantity: 1,
        stock: currentStoreStock
          ? {
              display: currentStoreStock.display,
              stock: currentStoreStock.stock,
            }
          : undefined,
        store: currentStore,
      });
      trackEvent(
        'clickandcollect_checkout',
        {
          currency: 'NOK',
          value: product.price.discountedAmount || undefined,
          items: [
            {
              item_id: product.sku,
              item_name: product.posterName,
              price: product.price.discountedAmount || undefined,
              quantity: 1,
            },
          ],
        },
        currentStore
      );
    } else {
      setShowStoreStock({
        title: 'Klikk og hent',
        visible: true,
        selectedProduct: omniumProduct,
        inventory: inventory || null,
      });

      setListenForStoreChange(true);
    }
  };

  useEffect(() => {
    if (listenForStoreChange && currentStore) {
      setListenForStoreChange(false);
      openClickAndCollect();
    }
  }, [listenForStoreChange, currentStore, openClickAndCollect]);

  const inventory =
    product.stock?.reduce((acc, stockItem) => {
      return {
        ...acc,
        [product.sku]: {
          [stockItem.storeId]: {
            display: stockItem.display,
            stock: stockItem.stock,
          },
        },
      };
    }, {}) || {};

  if (!currentStore || !currentStoreStock) return null;

  return (
    <Button
      disabled={currentStoreStock.stock < 1}
      className={twMerge(
        clsx('!bg-secondary-70 py-3.5', {
          '!bg-neutral-60 !text-neutral-40 cursor-default':
            currentStoreStock.stock < 1,
        })
      )}
      onClick={openClickAndCollect}
    >
      <span className="w-full text-center cap-sm font-bold">Klikk & Hent</span>
    </Button>
  );
}
